import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss']
})
export class InputSelectComponent implements OnInit {

  @Input() formParent: RxFormGroup;
  @Input() label: string;
  @Input() isLabelTop: false;
  @Input() frmControl: string;
  @Input() options: any;
  @Input() placeHolder: string;
  @Input() isUser = false;
  @Input() isPaymentList = false;

  @Output() value = new EventEmitter<any>();  
  control: any;
  placeholder = '';

  isOpen = false;

  constructor() { }

  ngOnInit(): void {
    this.placeholder = this.placeHolder ? this.placeHolder : '';
    this.control = this.formParent.controls[this.frmControl];
  }

  /**
   * Metodo para setear la opcion seleccionada
   * @param option opcion
   */
  optionSelected(option: any): void {   
    this.value.emit(this.control.value);
  }  

  // toggleSelect() {
  //   this.isOpen = !this.isOpen;
  // }


}
